import { request } from './client';

export function fetchCustomerAccount(customerId: number, params?: Record<string, string | number>) {
  return request('GET', `/v1/account/accounts/${customerId}`, params);
}
export function fetchCustomerAccounts(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/accounts', params);
}

export function fetchStats(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/stats', params);
}

export function fetchMetrics(params?: Record<string, string | number>) {
  return request('GET', '/v1/account/stats/available_metrics', params);
}

export function saveMetrics(params: Record<string, unknown>) {
  return request('POST', '/v1/account/stats/metrics', params);
}
